import { render, staticRenderFns } from "./Equivalences.vue?vue&type=template&id=947e94fc&scoped=true&"
import script from "./Equivalences.vue?vue&type=script&lang=ts&"
export * from "./Equivalences.vue?vue&type=script&lang=ts&"
import style0 from "./Equivalences.vue?vue&type=style&index=0&id=947e94fc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "947e94fc",
  null
  
)

export default component.exports